import type { IconType } from 'react-icons';
import { FaCrutch } from 'react-icons/fa';
import { FaUserDoctor } from 'react-icons/fa6';
import { GiKneeBandage } from 'react-icons/gi';
import { GrYoga } from 'react-icons/gr';
import {
  MdChildCare,
  MdOutlineElderly,
  MdOutlinePets,
  MdOutlinePregnantWoman,
  MdSportsGymnastics,
} from 'react-icons/md';
import { PiFlowerLotus } from 'react-icons/pi';
import { RiPlantFill } from 'react-icons/ri';

export type CATEGORY_DESCRIPTOR_TYPE = {
  id: string;
  icon: IconType;
};

export type TAG_DESCRIPTOR_TYPE = {
  id: string;
  icon: IconType;
};

export const CATEGORY_DESCRIPTORS: CATEGORY_DESCRIPTOR_TYPE[] = [
  {
    id: '8f3ba120-4d8c-4c1e-b627-88fc757f1c64',
    icon: MdSportsGymnastics,
  },
  {
    id: 'dabacad0-6a67-4e24-b31f-df13567bacb5',
    icon: MdOutlinePregnantWoman,
  },
  {
    id: '9067e082-a828-4ea5-8276-76029b021cc8',
    icon: MdOutlineElderly,
  },
  {
    id: '2145b2b7-7bf2-47d5-928a-292453059b0f',
    icon: MdChildCare,
  },
  {
    id: '2700fc13-6e0a-4e25-a216-262d0225f661',
    icon: FaCrutch,
  },
  {
    id: '1150faac-63b3-44b2-8fd0-33ce21fc5e96',
    icon: MdOutlinePets,
  },
  {
    id: 'f880ca79-e0ce-4fbf-b1bb-81c338dcd6b4',
    icon: GiKneeBandage,
  },
  {
    id: 'c2751259-cdc5-4214-82d3-29b1e4b3b80c',
    icon: GrYoga,
  },
  {
    id: '0e98b079-6395-46a0-829c-200c1a71a479',
    icon: RiPlantFill,
  },
  {
    id: '4c9f1da7-d3d4-4765-9834-55f3f6b0529c',
    icon: PiFlowerLotus,
  },
];

export const TAG_DESCRIPTORS: TAG_DESCRIPTOR_TYPE[] = [
  { id: 'fc98021d-2126-4e28-a1f3-f660792a6577', icon: FaUserDoctor },
  { id: '27011e17-e816-4156-857a-b979802d7fc6', icon: FaUserDoctor },
  { id: 'a7744666-cf26-47c6-a184-0cf6a45cf18b', icon: FaUserDoctor },
  { id: '709c8f17-33c2-409d-af3a-a728700a723d', icon: FaUserDoctor },
  { id: '4825b1fe-7aa3-4ada-8ba2-e51246b17b40', icon: FaUserDoctor },
  { id: '453245e5-4042-44e2-83ce-07aec219f30a', icon: FaUserDoctor },
  { id: '2cb6a5da-3419-414c-8e3e-4a078fb07b8f', icon: FaUserDoctor },
  { id: 'cc9949a0-f2b6-4385-b7a6-468d81e6796e', icon: FaUserDoctor },
  { id: 'd9e3b950-316b-4793-b303-32a7727acadd', icon: FaUserDoctor },
  { id: 'e1be1b28-989f-4c18-8da8-f407c40b6ee6', icon: FaUserDoctor },
  { id: '9dd49009-b52f-46de-8fa1-4dae2e267f30', icon: FaUserDoctor },
  { id: '2f2e5617-31fa-41ca-a4ac-332898631be1', icon: FaUserDoctor },
  { id: '34be340d-a8d8-4e62-86ee-5c951f28aa27', icon: FaUserDoctor },
  { id: '6b7dbe55-9377-40e1-a6fe-5c0dfa5b19ef', icon: FaUserDoctor },
  { id: '8609a0dd-22ae-4d48-9fda-4077e8fefae3', icon: FaUserDoctor },
  { id: 'df6f7c7a-4d67-4b42-8c3c-6ddac9c13cfa', icon: FaUserDoctor },
  { id: 'cf4bb9ee-033b-4ca3-b763-ead769a2d305', icon: FaUserDoctor },
  { id: '7ac6bced-9786-4e25-a8e9-a13ca2f39afc', icon: FaUserDoctor },
  { id: '6a3ff33e-92bf-4816-a66a-d9c26bd6d589', icon: FaUserDoctor },
  { id: 'd72e2b5d-54e3-4dfc-9f98-f3fa10596ff1', icon: FaUserDoctor },
  { id: 'b1e70abd-ff17-43ae-b225-04dc5b9f65fa', icon: FaUserDoctor },
  { id: '579cf9ee-d205-464d-bbbf-b796bb5e4f41', icon: FaUserDoctor },
  { id: 'db593f2b-7aee-44f4-8274-c3ab11459ebd', icon: FaUserDoctor },
  { id: '4ea35462-7693-4b4c-83c3-46f6c110098b', icon: FaUserDoctor },
  { id: 'eb935e4b-307f-4745-a9a6-c23083dd9be1', icon: FaUserDoctor },
  { id: 'df6c69ce-69ba-463c-b35d-bce63a5cd401', icon: FaUserDoctor },
  { id: 'c740313b-1833-40d0-baa7-11bb80350768', icon: FaUserDoctor },
  { id: '800127f6-71b4-45e1-a9d8-d0eb4201d2ce', icon: FaUserDoctor },
  { id: 'b5971770-c370-4491-adbb-ad2e48da4375', icon: FaUserDoctor },
  { id: '164b1292-ab49-4de6-8e02-ae9038a4e3c1', icon: FaUserDoctor },
  { id: '1529048c-2b86-4952-a5a1-2d54affb8378', icon: FaUserDoctor },
  { id: 'dc3b7738-47b2-4dd9-ab6a-d131b78e6563', icon: FaUserDoctor },
  { id: 'd313374b-6fcd-40e6-9d55-8de81d21d6c7', icon: FaUserDoctor },
  { id: '62dcc7fc-1d0b-410d-b839-704daee8cc7b', icon: FaUserDoctor },
  { id: '0e98257d-0611-43cd-9bb7-b0aac7f94440', icon: FaUserDoctor },
  { id: 'c06f7c71-a179-4228-9277-bbc5ecfb2937', icon: FaUserDoctor },
  { id: 'c12b1a38-ab03-4ce3-99e9-ff2c4046eac0', icon: FaUserDoctor },
  { id: '78776e61-1431-454b-b1a2-e7de3938d782', icon: FaUserDoctor },
  { id: '2b03c910-9ddc-4662-adfa-75dead4af6e2', icon: FaUserDoctor },
  { id: '419afb2f-77f3-437c-83be-1f333025b831', icon: FaUserDoctor },
  { id: 'bad22744-6c18-4db4-a15f-2ae2a403490b', icon: FaUserDoctor },
  { id: 'fabd20be-442a-4f9a-b983-465e283f2ea0', icon: FaUserDoctor },
  { id: '71ef4a5d-b588-4060-87d8-20166fd132e0', icon: FaUserDoctor },
  { id: 'f8040d12-52d1-44a4-b65e-432c9aebe67a', icon: FaUserDoctor },
  { id: '3fd32fbb-099d-4120-940e-792f4ee3b8e0', icon: FaUserDoctor },
  { id: 'a3fda5c9-5668-494e-9a18-1762d9aeea57', icon: FaUserDoctor },
  { id: '9457845b-e0c9-48fb-9cdc-c3aa40d913b4', icon: FaUserDoctor },
  { id: 'ba743591-56f8-41b0-9602-822cd8dff0eb', icon: FaUserDoctor },
  { id: '97253da4-77e3-4354-ac71-04a51d16fda4', icon: FaUserDoctor },
  { id: 'cb302c5f-fe00-440e-8afe-d5ca5e5ad48d', icon: FaUserDoctor },
  { id: '7d7752d1-daca-4b5c-ac8f-81f8cc0eecb5', icon: FaUserDoctor },
  { id: '681fb012-f374-494e-8a37-4b4469a7207d', icon: FaUserDoctor },
  { id: '926bf970-3f03-413f-92c4-0b71d70fa1fb', icon: FaUserDoctor },
  { id: 'd573d25e-a42f-4be3-85f5-7b25605aa233', icon: FaUserDoctor },
  { id: '695a9ca0-ac93-40a6-9848-9ceb5e9bbffc', icon: FaUserDoctor },
  { id: '919404e9-7505-47a2-867a-7cd8513b4a6e', icon: FaUserDoctor },
  { id: '7df670ee-cfcc-4721-add4-a1b8ba65376f', icon: FaUserDoctor },
  { id: '8f580c04-637c-4008-b826-829238447844', icon: FaUserDoctor },
  { id: 'b44280e2-6831-437d-b585-d71c50b21b66', icon: FaUserDoctor },
  { id: '40bbeec3-a295-4215-aef0-dd7f59fb32aa', icon: FaUserDoctor },
  { id: '546edd8d-663f-4383-bf35-96f08ac8ef3e', icon: FaUserDoctor },
  { id: '15b82434-ad69-410c-88e2-e80c5ecee21d', icon: FaUserDoctor },
  { id: '52cd5554-3a2e-46ca-a2ed-eb2f08c71f8d', icon: FaUserDoctor },
  { id: 'fa3cc123-c2f1-4cce-a226-b93f4c67450d', icon: FaUserDoctor },
  { id: '0182c98a-ab48-4266-9df7-f1bad76413a3', icon: FaUserDoctor },
  { id: '033e2c17-f567-42fe-8190-d9f10e63e739', icon: FaUserDoctor },
  { id: '6bef4f14-cac3-49c6-832e-352d975f3939', icon: FaUserDoctor },
  { id: 'f5d7c768-74f0-4fe9-a21f-7dcc95a76f1c', icon: FaUserDoctor },
  { id: '698481a4-2cb6-4731-8f85-fbbc0582d264', icon: FaUserDoctor },
  { id: '199bc0dc-2f84-43a6-b623-5964f2148010', icon: FaUserDoctor },
  { id: '8e5ad442-edc1-4e4f-aedd-70f6d000669e', icon: FaUserDoctor },
  { id: 'baf7cc2c-5bd2-4096-ad3b-ec8cc816e9c1', icon: FaUserDoctor },
  { id: '7f51bf1a-cbd4-4231-855d-ee31047c3ef5', icon: FaUserDoctor },
  { id: 'f70256ae-5649-4078-9270-7ada891049d3', icon: FaUserDoctor },
  { id: 'cdc312d7-ca96-4db7-9e2a-9b2dff859721', icon: FaUserDoctor },
  { id: 'e3203ddf-e0c2-4c87-90a3-e7eb6d4b9194', icon: FaUserDoctor },
  { id: '239d39fe-ed74-4928-a1ae-ae979986fefb', icon: FaUserDoctor },
  { id: 'ab882720-6eaa-4c58-b919-77e085b17161', icon: FaUserDoctor },
  { id: '83020675-9a8a-4cd1-8ce4-76dac907df16', icon: FaUserDoctor },
  { id: '44ccc6ea-23e1-491f-be43-365772ad3965', icon: FaUserDoctor },
  { id: '379473b8-ea34-47ba-9eff-34f254192e99', icon: FaUserDoctor },
  { id: '81fe6ea6-3f83-4014-9033-28ab73f3519d', icon: FaUserDoctor },
  { id: 'e8236f95-d4b7-4400-8c45-7581d1c62ee8', icon: FaUserDoctor },
  { id: '153d6c3b-8339-467a-9df2-101d1e855205', icon: FaUserDoctor },
  { id: '832aab8c-8f53-4d11-804a-b1bfa6393625', icon: FaUserDoctor },
  { id: '0fbaf87b-8034-48ab-96e5-4a1c5794bb40', icon: FaUserDoctor },
  { id: '67505de6-e755-40fa-8495-302b7c05b237', icon: FaUserDoctor },
  { id: '16bb3bac-89c5-40bc-8f3d-73d8ce179304', icon: FaUserDoctor },
  { id: '33458c57-040b-4feb-bb70-466dc06b22ca', icon: FaUserDoctor },
  { id: 'ed6d2ab6-5460-4dee-97de-66353921ffd4', icon: FaUserDoctor },
  { id: 'b8cfa3c5-b208-49b0-818a-d5eedac11966', icon: FaUserDoctor },
  { id: '20e56c93-efa8-46de-87f2-086714c3108d', icon: FaUserDoctor },
  { id: 'bc23b5ec-c8ba-4671-aff2-fe3edbbece3f', icon: FaUserDoctor },
  { id: '3150a19f-e2f7-4629-a3eb-0a50640367fc', icon: FaUserDoctor },
  { id: 'c422cf13-79da-4397-92c6-ee0358eee66d', icon: FaUserDoctor },
];
